import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e922d1fc&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e922d1fc')) {
      api.createRecord('e922d1fc', component.options)
    } else {
      api.reload('e922d1fc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e922d1fc&", function () {
      api.rerender('e922d1fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/playground/store/page/index.vue"
export default component.exports